@let statusses = ttmStatuses();
@let key = statusKey();

<mat-chip class="status-chip" [style.background-color]="'#' + (statusses | byKey: key)?.color"  [style.--mdc-chip-label-text-color]="textColor()">
    {{(statusses | byKey: key)?.name}}
</mat-chip>
